class RecruitForm {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $('[name=requirements-select] option').each(function() {
      if($(this).text() == '—Please choose an option—') {
        $(this).text('選択してください');
      }

      let url = new URL(window.location.href);
      let params = url.searchParams;
      
      if(params.get('id') == $(this).text()) {
        $(this).prop('selected', true);
      }
    })

    setTimeout(() => {
      $('.cd-upload-btn').off();
    }, 500);

    $('.wpcf7-submit').click(function() {
      const date = new Date();
      const formattedDate = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      const formattedTime = `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;

      $('.js-time').val(`${formattedDate} ${formattedTime}`);
    })
  }
}
